import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { DSSetup, Service } from 'webapp-types';
import type { Theme } from 'webapp/enums/enums';

import BillingLimitationWarningComponent from 'webapp/components/billing/limitation-warning';
import GoalSelectorComponent from 'webapp/components/goal/selector';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';
import type DsCompare from 'webapp/models-custom/ds-compare';
import type VisualizationGauge from 'webapp/models-custom/visualization/gauge';

interface Args {
	blockM: Block;
	model: DataSelect;
	theme?: Theme | string;
}

export default class BlockSettingsMetricGaugeGoalComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization as VisualizationGauge;
	}

	get dsCompare(): DsCompare | undefined {
		const indexForGoalCompare = 0;
		return this.args.model.limitations.compareCMs[indexForGoalCompare];
	}

	get goalsDisabledInBilling() {
		return !this.billingService.goalsEnabled;
	}

	get selectedGoalMetricData(): DSSetup.MetricData | null {
		return this.dsCompare?.metricSetup.metricData || null;
	}

	@action
	changeMaxMetricData(metricData: DSSetup.MetricData | null): void {
		this.updateOnCompare((compare: DsCompare) => {
			compare.metricSetup.setFromMetricData(metricData);
		});
	}

	private updateOnCompare(updateFn: (compare: DsCompare) => void) {
		const dataSelect = this.args.model,
			compares = dataSelect.limitations.compareCMs;

		const compare = this.dsCompare;
		if (compare) {
			updateFn(compare);
			this.updateCompares(compares);
		}
	}

	private updateCompares(compares: DsCompare[]) {
		const dataSelect = this.args.model;
		dataSelect.updateComparesFormulaArrayFromCompareModels(compares);
		this.blockSetup.saveDataSelect(dataSelect);
	}
	<template>
		<div class="row">
			<GoalSelectorComponent
				@selectedGoalMetricData={{this.selectedGoalMetricData}}
				@metricSetup={{@model.metricSetup}}
				@theme={{@theme}}
				@onChange={{this.changeMaxMetricData}}
				@onlyAutomaticEnabled={{true}}
				@origin="designer"
				@isGoalTypeObjectiveDisabled={{true}}
			/>
			{{#if this.goalsDisabledInBilling}}
				<BillingLimitationWarningComponent />
			{{/if}}
		</div>
	</template>
}
